import theme from "app/Theme/Theme";
import React from "react";
import { StyleSheet, TextInput } from "react-native";
import { Box } from "../Box";
import { MainText } from "../MainText";
import { SelectedInputProps } from "./types";

const styles = StyleSheet.create({
  textInput: {
    backgroundColor: theme.colors["neutral.75"],
    padding: theme.spacing["xs"],
    borderRadius: 8,
    color: theme.colors["neutral.900"],
    ...theme.body["l4-medium"],
    borderWidth: 1,
    borderColor: theme.colors["neutral.100"],
  },
});

interface InputsProps {
  placeholderTextInput?: string;
  styleTextInput?: {};
  multiline?: boolean;
  maxLength?: number;
  style?: {};
  onPress: (text: string) => void;
}

const InputText = ({
  placeholderText = "",
  onPress,
  selectedText = "",
  placeholderTextInput = "",
  styleTextInput = {},
  multiline = false,
  maxLength = undefined,
  style = {},
}: InputsProps & SelectedInputProps) => {
  const handleTextChange = (text: string) => {
    onPress(text);
  };

  return (
    <Box paddingHorizontal="xm" width="100%" style={style}>
      <MainText marginBottom="xxs" variant="l3-medium" color="neutral.600">
        {placeholderText}
      </MainText>
      <TextInput
        onChangeText={handleTextChange}
        style={[styles.textInput]}
        value={selectedText}
        placeholder={placeholderTextInput}
        multiline={multiline}
        maxLength={maxLength}
      />
    </Box>
  );
};

export { InputText };
